import { Paper, Typography, Container } from '@mui/material';
import '../../scss/components/mobile-payments.scss';
import { useParams, useNavigate } from 'react-router-dom';
import { Button as MUIButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const MobileNoPaymentProgramsView = () => {
  const { patientId, patientEncounterId } = useParams<{ patientId: string; patientEncounterId: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    if (patientId && patientEncounterId) {
      navigate(`/mobile/patient/${patientId}/ioc/${patientEncounterId}/program/optimal`);
    }
  };

  return (
    <Paper className="payment-wrapper" test-id="mobile-no-payment-programs-view">
      <Container>
        <MUIButton variant="text" onClick={handleBack} sx={{ mb: 2 }} test-id="mobile-no-programs-back-button">
          <ArrowBackIosIcon /> Back
        </MUIButton>
        <Typography variant="h3" className="pt-2" align="center" color="primary" test-id="mobile-no-programs-title">
          Mobile Program
        </Typography>
        <Typography variant="subtitle2" className="mt-2" align="center" test-id="mobile-no-programs-message">
          No alternative payment programs are currently available via mobile.
          <br />
          <br />
          For further help please contact {'support@provider.com'}
        </Typography>
      </Container>
    </Paper>
  );
};

export default MobileNoPaymentProgramsView;

